import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Switch,
  FormControlLabel,
  IconButton,
  
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"; 
import Header from "../../components/Header"


class UpdateEmployeeScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: true,
      employeeData: null,
      profile_pic: null,
      government_id: null,
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }

  componentDidMount() {
      const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.fetchData(this.props.match.params.id)
  }

 fetchData = async (id) => {
  const { status, message, data } = await API(this, "get", URL_PATH.employeeDetails(id))
  if (status == "success") {
     if (data.slug !== this.props.match.params.userSlug) {
    this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
    return;
  }
    this.setState({
      employeeData: data,
      active: data.status === 1,
      profile_pic_url: data.profile_pic,  // Store the URL
      government_id_url: data.government_id  // Store the URL
    })
  } else {
    this.showToast(message, "error");
  }
}

  handleInputChange = (event) => {
    const { name, value } = event.target
    this.setState((prevState) => ({
      employeeData: {
        ...prevState.employeeData,
        [name]: value,
      },
    }))
  }

  handleSwitchChange = (event) => {
    this.setState({ active: event.target.checked })
  }

  handleFileChange = (event, fileType) => {
    const file = event.target.files[0]
    if (file) {
      this.setState({ [fileType]: file })
    }
  }
handleFileDelete = (fileType) => {
  this.setState({ 
    [fileType]: null,
    [`${fileType}_url`]: null 
  })
}

  create = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.target)
    formData.append("status", this.state.active ? 1 : 0)
    formData.append("employee_id", this.props.match.params.id)

    if (!this.state.profile_pic && this.state.profile_pic_url) {
    formData.append("profile_pic_url", this.state.profile_pic_url)
  }
  if (!this.state.government_id && this.state.government_id_url) {
    formData.append("government_id_url", this.state.government_id_url)
  }

    const { status, message } = await API(this, "post", URL_PATH.updateEmployee, formData)
    if (status == "success") {
      // Replace window.Alert with state update for success modal
      this.showToast(message, "success");
                    this.props.history.push(routes.admin.employees.root(this.props.hotels[0]?.hotel_slug || ''))

    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "error");
    }
  }

  handleSuccessModalClose = () => {
    // Close success modal and redirect
    this.setState({ showSuccessModal: false })
    this.props.history.push(routes.admin.employees.list)
  }

  handleErrorModalClose = () => {
    // Close error modal
    this.setState({ showErrorModal: false })
  }

renderFileUpload = (fileType, label) => {
  const file = this.state[fileType];
  const fileUrl = this.state[`${fileType}_url`];  // Get the URL from state

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        {label}
      </Typography>
      <Box
        sx={{
          mt: 1,
          border: "1px dashed rgba(255, 255, 255, 0.23)",
          borderRadius: "8px",
          p: 3,
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        <input
          type="file"
          id={fileType}
          name={fileType}
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => this.handleFileChange(e, fileType)}
        />
        {file ? (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography>{file.name}</Typography>
            <IconButton onClick={() => this.handleFileDelete(fileType)} size="small">
              <DeleteIcon />
            </IconButton>
          </Box>
        ) : fileUrl ? (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <Typography>View Current File</Typography>
            </a>
            <IconButton onClick={() => this.handleFileDelete(fileType)} size="small">
              <DeleteIcon />
            </IconButton>
          </Box>
        ) : (
          <label htmlFor={fileType} style={{ cursor: "pointer" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px dashed rgba(255, 255, 255, 0.23)",
                    borderRadius: "4px",
                    mb: 1,
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </Box>
                <Typography>Upload a file</Typography>
                <Typography variant="caption" color="text.secondary">
                  PNG, JPG, GIF, PDF up to 1.0MB
                </Typography>
              </Box>
            </label>
          )}
        </Box>
      </Box>
    )
  }

  render() {
    const { employeeData } = this.state
    if (!employeeData) return null

    return (
      <Container maxWidth="lg">
       

        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
           <CardHeader
                      title={
                        <Header title="Update Employee" />
          
                      }
                      sx={{  }}
                    />
          <CardContent>
            <form onSubmit={this.create}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  {this.renderFileUpload("profile_pic", "Profile Picture")}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {this.renderFileUpload("government_id", "Government ID")}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee Name"
                    name="name"
                    value={employeeData.name}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={employeeData.email}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    value={employeeData.phone}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                <style>
                    {`
                   input[type="date"]::-webkit-calendar-picker-indicator {
                  filter: invert(1); /* Inverts the color to white */
                   }
                  `}
                  </style>
                  <TextField
                    fullWidth
                    label="Date of Birth"
                    name="dob"
                    type="date"
                    value={employeeData.dob}
                    onChange={this.handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={employeeData.address}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Designation"
                    name="designation"
                    value={employeeData.designation}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Hired Date"
                    name="date_hired"
                    type="date"
                    value={employeeData.date_hired}
                    onChange={this.handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Education"
                    name="education"
                    value={employeeData.education}
                    onChange={this.handleInputChange}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.active}
                        onChange={this.handleSwitchChange}
                        name="active"
                        color="primary"
                      />
                    }
                    label="Active"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      bgcolor: "#FFC857",
                      fontWeight: "700",
                      "&:hover": { bgcolor: "#E6B54E" },
                    }}
                  >
                    Update Employee
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={this.handleCloseToast}
      />
      </Container>
    )
  }
}

export default redux(UpdateEmployeeScreen)